import { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { selectCount, selectAnimation, resetAnimation, } from "../features/counter/counterSlice";
import { useSelector, useDispatch } from "react-redux";
import logoImageWhite from "../Images/full-logo.png";
import userImage from "../Images/userAccount.png";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import topPattern from "../Images/pattern_top.png";
import Tooltip from "@mui/material/Tooltip";

import { usePaymentMode } from "../context/PaymentModeContext";
// import { useLocation } from "react-router-dom";

import firebaseApp from "../firebase";
import { getAuth, signOut } from "firebase/auth";

function AOSHAdminPrivelage(email) {
  email = email?.toLowerCase() ?? "";
  return (email === "d.mathieu@especsoftware.com"  || // Davis Mathieu
          email === "n.king@phoenixenv.com"        || // Nate King
          email === "d.smith@phoenixenv.com"       || // Davis Smith
          email === "s.halberstadt@phoenixenv.com" || // Shauna Halberstadt
          email === "oscar@aosh.net"               || // Oscar Milian
          email === "c.smith@phoenixenv.com"          // Casey Smith
          )  
}
function UserMetricAdminPrivelage(email) {
  email = email?.toLowerCase() ?? "";
  return (email === "d.mathieu@especsoftware.com" ||  // Davis Mathieu
          email === "d.smith@phoenixenv.com"        // Davis Smith
          )
}

function PaymentMethodSwitch(email) {
  email = email?.toLowerCase() ?? "";
  return (email === "d.mathieu@especsoftware.com"  || // Davis Mathieu
          email === "d.smith@phoenixenv.com"       || // Davis Smith
          email === "s.halberstadt@phoenixenv.com" || // Shauna Halberstadt
          email === "n.king@phoenixenv.com"        || // Nate King
          email === "a.hinken@phoenixenv.com"      || // Alex Hinken
          email === "m.goodwin@phoenixenv.com"     || // Mike Goodwin
          email === "c.smith@phoenixenv.com"          // Casey Smith
        ) 
}

function Header(props) {
  const [userProfileImage] = useState(null);
  const history = useNavigate();
  const dispatch = useDispatch();
  const items = useSelector(selectCount);
  const animate = useSelector(selectAnimation);
  const [animateState, setAnimateState] = useState(false);
  const [,setStateButton] = useState("States");
  const [, setStateName] = useState(null);
  const [, setSearchKey] = useState("");

  const {mode, setMode } = usePaymentMode();
  const isOn = mode === "live";

  useEffect(() => {
    if (animate) {
      setAnimateState(true);
      const timer = setTimeout(() => {
        dispatch(resetAnimation());
        setAnimateState(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [animate, dispatch]);

  // useEffect(() => {
  //   console.log(props.userInfo.email)
  // })

  useEffect(() => {
    let states = JSON.parse(localStorage.getItem("states"));
    if (states === "" || states === null) {
      setStateName(props.state);
    } else {
      setStateName(states);
    }
  }, [props.state]);

  const directToBasket = () => {
    history("/basket");
  };

  const directToHome = () => {
    if (!props?.passLaraUser) {
      setStateButton("States");
      setSearchKey("");
      props.passState("All");
      props.changeSearchKey("");
      history("/");
    }
  };

  const onClickLogin = () => {
    history("/login");
  };

  const onClickSignUp = () => {
    history("/signup");
  };

  const onClickMyCourses = () => {
    history("/mycourses");
  };

  const onClickLogOut = () => {
    const auth = getAuth(firebaseApp);
    signOut(auth)
      .then(() => {
        localStorage.removeItem("user");
        props.passUser(null);
        history("/");
      })
      .catch((error) => { });
  };

  const onClickMyOrders = () => {
    history("/myorders");
  };

  const onClickMyCompany = () => {
    history("/myteam");
  };

  const onClickAOSHFinance = () => {
    history("/budgetreport");
  };
  const onClickUserTeamExpirationData = () => {
    history("/teamExpirationReport")
  }

  const onClickMyCertificates = () => {
    history("/mycertificates");
  };

  const onClickNotifications = () => {
    history("/notifications");
  };
  
  const onClickLaraLogin = () => {
    history("/laracheckstatus");
  };


  return (
    <Container>
      <LogoContainer>
        <Logo src={logoImageWhite} onClick={directToHome} />
      </LogoContainer>      

      {!props?.passLaraUser && (
        <UserContainer>
          <USTSearch
            style={{ zIndex: 10001 }}>
            <USTLogoContainer onClick={() => onClickLaraLogin()}>
              Search Valid Certificates
            </USTLogoContainer>
          </USTSearch>
          { AOSHAdminPrivelage(props.userInfo?.email) && ( 
            <Tooltip
              title="Financial Stats"
              style={{ zIndex: 10000000000000000000000000001 }}>
              <FinanceStats onClick={() => onClickAOSHFinance()}>
                <div style={{ display: "flex", gap: "1px", alignItems: "flex-end",  justifyContent: "center" }}>
                  <AnalyticsBar style={{height: "10px"}}/>
                  <AnalyticsBar style={{height: "18px"}}/>
                  <AnalyticsBar style={{height: "25px"}}/>
                </div>
              </FinanceStats>
            </Tooltip>
          )}
          {  UserMetricAdminPrivelage(props.userInfo?.email) && ( 
            <Tooltip
              title="Team Expiration Stats"
              style={{ zIndex: 10000000000000000000000000001 }}>
              <FinanceStats onClick={() => onClickUserTeamExpirationData()}>
                <div style={{ display: "flex", gap: "1px", alignItems: "flex-end",  justifyContent: "center" }}>
                  <AnalyticsBar style={{height: "25px", background: "linear-gradient( to top, #000000 0%, orange 80%)"}}/>
                  <AnalyticsBar style={{height: "25px", background: "linear-gradient( to top, #000000 0%, orange 80%)"}}/>
                  <AnalyticsBar style={{height: "25px", background: "linear-gradient( to top, #000000 0%, orange 80%)"}}/>
                </div>
              </FinanceStats>
            </Tooltip>
          )}
          {PaymentMethodSwitch(props.userInfo?.email) && (
            <Tooltip
              title={mode === "live" ? "Standard Pay" : "Admin Pay"}
              style={{ zIndex: 10000000000000000000000000001 }}
            >
              <TestState
                onClick={() => setMode((prev) => (prev === "live" ? "test" : "live"))}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setMode((prev) => (prev === "live" ? "test" : "live"));
                  }
                }}
              >
                <PaymentMethodToggleContainer $isOn={isOn}>
                  <PaymentMethodToggle $isOn={isOn} />
                </PaymentMethodToggleContainer>
              </TestState>
            </Tooltip>
          )}
          {props.userInfo && (
            <Tooltip
              title="Notification"
              style={{ zIndex: 10001 }}>
              <LogoutLogoContainer onClick={() => onClickNotifications()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-bell"
                  viewBox="0 0 16 16"
                  style={{
                    fill: "black",
                    height: "20px",
                    width: "20px",
                  }}>
                  <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                </svg>
                {props.numberOfNotifications > 0 && (
                  <CartCount>
                    <CartNum>{props.numberOfNotifications}</CartNum>
                  </CartCount>
                )}
                
              </LogoutLogoContainer>
            </Tooltip>
          )}
          {props.userInfo && (
            <Tooltip
              title="Personal Cart"
              style={{ zIndex: 10000000000000000000000000001 }}>
              <MenuCart className="cart-container" onClick={directToBasket}>
                <ShoppingCartIcon className={ animateState ? "add-item-to-cart" : "shopping-cart" } />
                {items.length > 0 && (
                  <CartCount>
                    <CartNum>{items.length}</CartNum>
                  </CartCount>
                )}
              </MenuCart>
            </Tooltip>
          )}

          {props.userInfo ? (
            <UserImageContainer>
              {/* Dropdown menu start */}
              <div className="app-symbolic-menu">
                <div className="dropdown" style={{ float: `right` }}>
                  {userProfileImage ? (
                    <UserImage src={userImage} />
                  ) : (
                    <AnotherUser>
                      <PersonIcon
                        style={{ fill: "black", height: "20px", width: "20px" }}
                        className="person-icon"
                      />
                    </AnotherUser>
                  )}

                  <div className="dropdown-content">
                    <div className="first-manu-item">
                      {/* <span> */}
                      <div className="menu-profile-icon-container">
                        <div className="menu-profile-icon">
                          <UserIcon
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-person-circle"
                            viewBox="0 0 16 16">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                              fillRule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                          </UserIcon>

                          <div className="menu-profile-camera">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-camera-fill"
                              viewBox="0 0 16 16">
                              <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                              <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      {/* </span> */}
                      <div className="use-name-email">
                        {/* <p>user's name</p> */}
                        <p>{props.userInfo.fullName}</p>
                        <p>{props.userInfo.email}</p>
                      </div>
                    </div>

                    <span onClick={() => onClickMyCourses()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-person-video2"
                        viewBox="0 0 16 16">
                        <path
                          d="M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                          fill="#000"
                        />
                        <path
                          d="M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2ZM1 3a1 1 0 0 1 1-1h2v2H1V3Zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5Zm-4-2h3v2H2a1 1 0 0 1-1-1v-1Zm3-1H1V8h3v2Zm0-3H1V5h3v2Z"
                          fill="#000"
                        />
                      </svg>
                      <a href="/mycourses">My Courses</a>
                    </span>

                    <span onClick={() => onClickMyCertificates()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-folder"
                        viewBox="0 0 16 16">
                        <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z" />
                      </svg>
                      <a href="/mycertificates">My Certificates</a>
                    </span>

                    <span onClick={() => onClickMyOrders()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bag-check-fill"
                        viewBox="0 0 16 16">
                        <path
                          fillRule="evenodd"
                          d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zm-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                        />
                      </svg>
                      <a href="/myorders">My Orders</a>
                    </span>

                    <span onClick={() => onClickMyCompany()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-people-fill"
                        viewBox="0 0 16 16">
                        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        <path
                          fillRule="evenodd"
                          d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                        />
                        <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                      </svg>
                      <a href="myteam">My Teams</a>
                    </span>

                    <span onClick={() => onClickNotifications()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bell"
                        viewBox="0 0 16 16">
                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                      </svg>
                      <NotificationWrapper>
                        {props?.numberOfNotifications > 0 &&
                          <NotificationBadge>
                            {props.numberOfNotifications}
                          </NotificationBadge>
                        }
                        <a href="notifications">Notifications</a>
                      </NotificationWrapper>
                      
                    </span>

                    <span
                      style={{
                        borderTop: "1px solid #bfbfbf",
                        justifyContent: "center",
                      }}
                      onClick={() => onClickLogOut()}>
                      <a href="/">Logout</a>
                    </span>
                  </div>
                </div>
              </div>
              {/* Dropdown menu end */}
            </UserImageContainer>
          ) : (
            <LoginSignUpContainer>
              <LoginButton  onClick={() => onClickLogin()} >Login </LoginButton>
              <SignUpButton onClick={() => onClickSignUp()}>Signup</SignUpButton>
            </LoginSignUpContainer>
          )}
        </UserContainer>
      )}
    </Container>
  );
}

export default Header;

const Container = styled.div`
  position: fixed;
  display: flex;
  width: 100%;
  z-index: 10;
  height: 70px;
  grid-template-columns: auto 300px !important;
  background-color: rgba(242, 242, 242, 0.8);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28' width='56' height='28'%3E%3Cpath fill='%23bbbbbb' fill-opacity='0.4' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E");

  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  color: #bbd5d2;
  justify-content: space-between; */

  &::before {
    content: "";
    /* background-image: url("https://placekitten.com/1200/800"); */
    /* background: url(${topPattern}) repeat center center; */
    /* background-size: cover; */
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.3;
  }
`;

const AnotherUser = styled.div`
  /* background-color: rgba(47, 72, 88, 0); */
  background-color: white;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  border-radius: 50%;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 10px; */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 40%);
  }
`;

const LogoContainer = styled.div`
  width: fit-content;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  margin: 0px 0px 0px 20px;
  /* cursor: pointer; */
  height: 100%;
`;
const Logo = styled.img`
  cursor: pointer;
  height: 80%;
  image-rendering: crisp-edges;
  image-rendering: -webkit-optimize-contrast;
`;

const UserContainer = styled.div`
  display: flex;
  flex-shrink: 1;
  min-width: 0px;
  align-items: center;
  justify-content: right;
  margin-right: 20px;
  height: 100%;
`;

const UserImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
  /* background-color: red;
  background-blend-mode: multiply; */
`;

const USTSearch = styled.div``;

const FinanceStats = styled.div`
  color: black;
  background-color: white;
  border: 3px solid #c6c6c6;
  border-radius: 25%;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  font-weight: 600;
  font-size: 0.8rem;

  width: 40px;
  height: 60%;

  margin-right: 10px;
  padding: 2px 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 2px 15px 0px rgb(0 0 0 / 40%);
  }
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const TestState = styled.div`
  color: black;
  background-color: white;
  border: 3px solid #c6c6c6;
  border-radius: 25px;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  font-weight: 600;
  font-size: 0.8rem;

  width: 20px;
  height: 58%;

  margin-right: 10px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;


  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 2px 15px 0px rgb(0 0 0 / 40%);
  }
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const PaymentMethodToggleContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 15px;
  background-color: ${({ $isOn }) => ($isOn ? "" : "#ffbd43")};
  padding: 2px;
  transition: background-color 0.4s ease;
`;

const PaymentMethodToggle = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: ${({ $isOn }) => ($isOn ? "2px" : "calc(100% - 14px)")};

  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: #7e7e7e;
  border: 1px solid #c6c6c6;

  transition: top 0.4s ease;
`;


const AnalyticsBar = styled.div`
  width: 8px;
  background: linear-gradient( to top, #000000 0%, #3de26b 80%);
  border-radius: 4px;
  box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 10%);
`;

const UserImageContainer = styled.div`
  border: 3px solid #c6c6c6;
  border-radius: 50%;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover + .cart-container {
    opacity: 0;
  }

`;

const MenuCart = styled.div`
  border: 3px solid #c6c6c6;
  /* fill: #09323b; */
  background-color: white;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  /* padding: 4px; */
  padding: 9px 9px 9px 9px;
  cursor: pointer;
  position: relative;
  /* border: 1px solid #04b16f;
  border-radius: 50%; */
  /* padding: 0 20px 0 0px; */
  /* width: fit-content;
  height: 100%; */
  /* width: 27px;
  height: 27px; */
  display: flex;
  align-content: center;
  transition: all 0.2s ease-in-out;
  /* transform: translate(0, 0); */
  opacity: 1;
  justify-content: center;
  align-items: center;
  /* transform: translate(0, 0); */

  &:hover {
    box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 40%);

    /* .shopping-cart {
      fill: rgb(95, 176, 95) !important;
    } */
  }
  transition: transform 0.2s ease-in-out;
`;

const UserIcon = styled.svg`
  width: 100%;
  height: 100%;
  object-fit: contain;

  /* fill: #04b16f; */
  /* fill: black; */
  /* fill: #737373; */
  /* fill: #5fb05f; */
  /* fill: #38668e; */
  /* fill: #031316; */
  /* fill: white; */
  fill: #09323b;
  /* border-radius: 50%; */
`;

const CartCount = styled.div`
  position: absolute;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: #ff6275;
  color: white;
  top: -9px;
  right: -10px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 10px;
  border: 2px solid white;

  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
`;

const CartNum = styled.p`
  white-space: nowrap;
  margin: 0px;
  padding: 0px;
  line-height: 6px;
`;

const LoginSignUpContainer = styled.div`
  z-index: 1;
  display: flex;
`;
const LoginButton = styled.button`
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border: none;
  outline: none;
  padding: 9px 20px;
  font-weight: 600;
  color: white;
  background-color: #09323b;
  border-radius: 0px 0px 0px 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(9, 50, 59, 0.9);
  }
`;
const SignUpButton = styled.button`
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border: none;
  outline: none;
  padding: 8px 16px;
  font-weight: 600;
  color: black;
  background-color: #5fb05f;
  border-radius: 0px 10px 0px 0px;
  cursor: pointer;

  &:hover {
    background-color: rgba(95, 176, 95, 0.9);
  }
`;

const LogoutLogoContainer = styled.div`
  border: 3px solid #c6c6c6;
  position: relative;
  z-index: 1;
  background-color: white;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  border-radius: 50%;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 2px 15px 0px rgb(0 0 0 / 40%);
  }
`;

const USTLogoContainer = styled.div`
  /* background-color: rgba(47, 72, 88, 0); */
  position: relative;
  z-index: 1;
  max-height: 34px;
  background-color: #F2F2F2;
  border: 3px solid #c6c6c6;
  color: #909090;
  font-size: 0.8rem;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  border-radius: 10px 10px 10px 10px;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 2px 15px 0px rgb(0 0 0 / 40%);
  }

  @media (max-width: 540px) {
    display: none;
    width: 1px;
    padding: 0px;
    margin: 0px;
  }
`;


const NotificationWrapper = styled.div`
  padding-left: 16px;
  position: relative;
`;
const NotificationBadge = styled.div`
  position: absolute;
  padding: 4px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  background-color: #ff6275;
  color: white;
  top: -11px;
  right: -15px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 10px;
  border: 2px solid white;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 30%);
  white-space: nowrap;
  margin: 0px;

  line-height: 6px;
`;